module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentc"
  }, [_vm._v("ABSINTHE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A liqueur made in France from Artemisia absinthium, a plant native to North Africa and the foothills and valleys of European mountain ranges. The liqueur is green in color and is compounded of marjoram, oil of aniseed, dill, and other aromatic oils.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Artemisia absinthium, also known as wormwood, was used in ancient times to banish demons. It was associated with the rites of St. John’s Eve, when a crown of the plant was supposed to ward off evil spirits. Tradition has it that John the Baptist wore a girdle of wormwood while he was in the wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wormwood was dedicated to the Greek goddess Artemis, hence the name Artemisia absinthium. Other classical references to this herb are Dioscorides, a Greek physician of the first century A.D., who declared that it prevented intoxication. The Roman scholar Pliny the Elder endorsed it as a great sexual restorative.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Absinthe was used extensively as a sexual stimulant by turning-of-the century artistic communities, especially in Paris. It is considered to be dangerous taken in large quantities.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In England the plant is called Green Ginger and Old Woman. Other names for the plant are Boy’s Love, Lad’s Love, and Maiden’s Ruin.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AGATE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Like a great many other stones, precious and semiprecious, the agate has a reputation for stimulating amorous activity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AISCHROLOGIA")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The frank expression of obsenities is considered to be an indirect sexual stimulant and was common in ancient Greek comedy, particularly that of Aristophanes. Famous literary examples of the twentieth century are James Joyce’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ulysses")]), _vm._v(", D.H. Lawrence’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lady Chatterly’s Lover")]), _vm._v(" and the books of Henry Miller.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ALBERTUS MAGUS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("This great medieval theologian and scientist, who was the teacher of Thomas Aquinas, offered numerous formulas for love potions in his works. He particularly recommends the brains of a partridge calcined into a powder and swallowed in red wine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ALCHEMICAL APHRODISIAC")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In the Middle Ages the alchemists sold a putative aphrodisiac which included gold as an ingredient. The "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("preparation was in the form of a beverage to be taken daily and was called “potable gold.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ALCOHOL")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Alcohol with sugar added was used to promote the amorous feelings of King Louis XIV. In some European countries it was a folk custom to offer a bride and bridegroom cakes moistened with sugar and alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In small amounts, alcohol removes inhibitions by depressing the “higher centers” of the brain and often is the major ingredient in aphrodisiacs. Sexual desire may be increased; however, consummation is negligible or abortive. As the Porter in Shakespeare’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Macbeth")]), _vm._v(" put it, “It (alcohol) provokes the desire, but it takes away the performance.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ALMONDS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Perfumed Garden")]), _vm._v(", an erotic handbook written by a sixteenth century Arab sheik, recommends almonds as an aphrodisiac: “Drink a glassful of very thick honey, eat twenty almonds and one hundred grains of the pine tree before bedtime. Continue for three successive days.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("ALMOND NECTAR")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("4 servings")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("1 cup milk")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("1/8 tsp. cinnamon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("6 raw almonds")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("1/8 cup dates")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mix together in a blender and serve hot or cold.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ALMOND SOUP")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("This aphrodisical soup contains powdered almonds, yolk of eggs, chicken stock, and cream. Many so-called aphrodisiac recipes are basically wholesome ingredients prepared in a tasty way. The receptivity to romance probably comes from the general sense of relaxation and well-being good food induces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AMAZONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("According to Eustathius, the twelfth century historian and scholar, the ancient Amazons had the strange custom of breaking the leg or arm of any captive taken in battle. The intention was not to prevent the possibility of escape, but to render the captive more vigorous for amatory conflicts, as the Amazons imagined that the genital members would be strengthened by the deprivation of one of the captive’s limbs. Hence, when reproached by the Scythians for the limping gait of her slaves, Queen Antianara replied, “The lame best perform the act of love.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AMBER")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In old pharmacopoeias many formulas were enumerated in which amber constituted the base. These recipes were all directed toward amatory capacity as their names imply, e.g.: Tables of Magnanimity, Electuary Satyrion, Joy Powder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AMBERGRIS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A waxy substance found in tropical seas, believed to be the secretion in the intestines of the sperm whale. Used in cooking as an aphrodisiac.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Among the Persians, pastilles consisting of powdered ambergris, rubies, gold, and pearls were eaten as an aphrodisiac.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the Orient, ambergris is still considered a potent aphrodisiac. Coffee is often served with a little ambergris at the bottom of the cup. According to one authority, three grains of ambergris are sufficient to produce, among other effects, a disposition to cheerfulness and sexual desire.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Among the ancients, ambergris was also used to restore vital powers that had been exhausted by old age or excess.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AMOROUS INDUCEMENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In giving advice on love and sex to his fellow Romans, the poet Ovid emphasizes a number of points that favor erotic conditions: a suntan, cleanliness, neat dress, brushed teeth, well-fitting sandals, and a good haircut.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For women Ovid suggests an elegant coiffure, dress that is becoming to the wearer’s shape and complexion, a graceful gait, well-controlled laughter when the occasion arises. For erotic interaction Ovid advises aggressivess. “Love hates laziness,” he warns.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANANGA-RANGA")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A Sanskrit manual written by Kalyanamalla, similar in content to Ovid’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ars Amatoria.")]), _vm._v(" This guide has been translated into a number of Indian languages, and also was translated into English by Sir Richard "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Burton. It deals with a vast array of love-making techniques, cosmetic and beautifying hints, aphrodisiac prescriptions, magic onintments for securing and retaining affection and love for both men and women, perfumes, bodily hygiene, hair treatments, drugs, philtres, pills, incense, charms for erotic subjugation, and magic incantations for the purpose of fascination.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANAPHRODISIACS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Excessive indulgence in alcohol diminishes sexual desire. Hindu texts often mention this condition. It is also familiar to the ancient classical writers. Tobacco and the plant valerian are also considered to be anaphrodisiac in their effects.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Water-purslan, cucumbers, even a drink of water have all had a reputation as being antiaphrodisiacs. Other means of cutting down sexual desire are a spare diet, a laborious life, little sleep, and much bodily exercise.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In ancient times, a cool regimen was suggested for quenching desire. Plato and Aristotle advised going barefoot as a means of checking the stimulus to carnal pleasure. The cold bath was considered equally efficacious. Others, including Pliny the Elder who authored the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historia Naturalis")]), _vm._v(", and the physician Galen, the second century A.D. Greek authority whose reputation extended far into the Middle Ages, advised thin sheets of lead to be worn on the calves of the legs and near the kidneys.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Remedia Amoris")]), _vm._v(", the Roman poet Ovid had the "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("following to say about subduing sexual energy:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Venus loves idleness. If you seek an end to love, be active, you will be safe …. Take up law … or busy yourself with agriculture … or hunting … or fishing … magic rites are useless. Think of our love’s faults and defects, avoid solitude. Shun loving couples, shun public groups, public performances, and shows. And avoid certain aphrodisiac foods, such as onions and rockets (a form of cabbage).")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a general sense, intense mental study, neurotic anxiety, fasting, excessive sleep, snuff-taking, have all been at various times considered detrimental to amatory activity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANCHOVIES")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In Southern European countries, they have long been reputed to be lust-provoking. If nothing more, they are gastronomically appealing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANGEL WATER")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("First used by the Portuguese. Popular in the eighteenth century. Shake together a pint of orange flower water, a pint of rose water, a half pint of myrtle water. Add two thirds of distilled spirit of musk, two thirds of spirit of ambergris. A reputed aphrodisiac aid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANISE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A plant indigenous to the Eastern Mediterranian area.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a culinary ingredient it acts as a sexual stimulant and enjoys a reputation as such among gourmets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A medieval aphrodisiac recipe contained dried black ants. Oil was poured over them and they were enclosed in a glass jar, ready for use.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ANVALLI")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A sexual stimulant mentioned in the Hindu erotic manual "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ananga-Ranga.")]), _vm._v(" It consists of the outer shell of the anvalli nut, from which the juice is extracted. Dried in the sun, this juice is mixed with powder of the same nut. The compound is eaten with candied sugar, clarified butter, and honey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APADRAVYAS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In Hindu erotology, these are objects of various kinds and designs, mostly metallic, that are used in connection with sexual activity. They are primarily intended to aid and prolong erection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIA")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A popular Greek festival held in honor of the goddess Aphrodite, patroness of love. At this festival prostitutes and hetairai, the Greek name for courtesans, were important participants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIAC CAKES")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In ancient Syracuse, cakes were made in the shape of the female genitalia and offered in divine sacrificial rites. Pastries resembling both male and female sex organs were common in medieval times, particularly "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An English example was called “cockle bread.” A young girl would knead a small piece of dough and then press it to her vulva. This mold was then baked and offered to the man of her choice. If the fellow ate it, he would fall under her spell.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIAC OINTMENT")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A recipe for an ointment to be applied to the male genitalia before sex consists of powdered white thorn-apple, king pepper, black pepper and honey. Aside from the lubricating powers of the honey, the pepper ingredients may actually aid erection by increasing the blood supply. Chemicals present in the thorn-apple are absorbed through the tissues of both male and female sex organs. These chemicals have properties that would induce, excitement, sedation and hallucination.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIAC PILL")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A Chinese pill intended to augment virile capacity. It is described by the Orientalist and anthropologist Sir Richard Burton as rhubarb colored, and enclosed in a wax capsule. The composition of the pill consists of vegetable extracts and vegetable matter. Dissolved in water, it is applied to the generative member.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIACS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("By definition, aphrodisiacs imply a stimulus to love. The term is derived from Aphrodite, the Greek goddess, in her capacity as a personification of the sexual urge, generation, and the power of love. To the Greek "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("and Roman poets, Aphrodite is the generative force that pervades the entire cosmos.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In his poem "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Rerum Natura")]), _vm._v(" the Roman poet Lucretius invokes the goddess under her Roman name of Venus:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mother of the descendants of Aeneas, delight of men and gods, O nourishing Venus, beneath the gliding constellations of heaven you fill the sea with sails and the lands with produce, since through you every kind of living creature is conceived, coming forth to gaze upon the light of the sun.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aphrodisiacs involve visual images, olfactory and tactile experiences, physiological operations related to food, drink, drugs, or conceptual pictures inducing libidinous thoughts and impulses. Some so-called aphrodisiacs are, though not effective, at least innocuous, while others may be extremely harmful and dangerous. It is wise, therefore, to take all aphrodisiacs, both figuratively and physiologically, with a grain of salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The usefulness of aphrodisiacs is often a matter of longstanding tradition, untested for validity, but wishfully handed down through the centuries in legends and folk tales, in magic rituals and old wives’ lore. In most cases there has been no definitive pharmaceutical or medical approval to warrant such belief. What may be safely asserted is that an abundance of rich "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("and appealing food, reinforced with palatable drinks, all consumed in a pleasant atmosphere in congenial company, will unquestionably induce a feeling of euphoria that may tend toward sensual directions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For centuries writers have discussed the use of aphrodisiacs. Rabelais (1490–1553) wrote wittily and in detail on this subject in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gargantua and Pantagruel")]), _vm._v(" wherein he recommends a moderate intake of wine:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As is implied by the old proverb, which saith that Venus takes cold when not accompanied by Ceres and Bacchus …. The philosophers say that ‘idleness is the mother of luxury.’ Who were able to rid the world of loitering and laziness might easily frustrate and disappoint Cupid of all his designs, aims, engines, and devices, and so disable and appall him that his bow, quiver, and darts should from thenceforth be a mere needless load and burden to him, for that it could not then lie in his power to strike or wound any of either sex, with all the arms he had. He is not, I believe, so expert an archer, as that he can hit cranes flying in the air, or yet the young stags skipping through the thickets, … that is to say, people moiling, stirring, and hurrying up and down, restless, and without repose. He must have those hushed, still, quiet, lying at a stay, lither, and full of ease, whom he is able to pierce with all his arrows.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Diogenes defined lechery as the occupation of folks destitute of all other occupation. Seneca, the Roman philosopher and tutor of the Emperor Nero says that love is a mental condition fostered by leisure. Further,")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Love is a mighty force of the mind, and a gentle mental heat produced by youthful lust, nourished by idleness amidst the good things that life brings.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIACS FOR SALE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In ancient Rome, love concoctions of all kinds were sold publicly. Poets and imperial officials, travelers and roués, idle matrons and hardened soldiers, resorted to such aphrodisiac support without hesitation of self-consciousness.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODISIAC WINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("An Italian recipe that has a presumptive amatory effect contains wine, ginger, cinnamon, rhubarb, and vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODITE")]), _vm._v(" "), _c('div', {
    staticClass: "quotes"
  }, [_c('p', {
    staticClass: "quotes"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The great and amorous sky curved over the earth, and lay upon her as a pure lover. The rain, the humid flux descending from heaven for both man and animal, for both thick and strong, germinated the wheat, swelled the furrows with fecund mud, and brought forth the buds in the orchards. And it is I who empowered these moist espousals, I, the great Aphrodite ….")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Aeschylus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Danaides")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The great, the golden Aphrodite. What better appelation could there be for this powerful manifestation of the primordial feminine energy of the universe? Gold is the color of the heart chakra and it is the heart that unites what is below with what is above, the body with soul, the emotions with the intellect, the earth with the heavens. Aphrodite, Goddess of Love, is the essence of loving attachment and the source of the earth’s fecundity. As Aphrodite Ourania she is Queen of Heaven, goddess of the purest love. As Aphrodite Pandemos, she is the principle of amity and loving kindness that civilizes the human race. Further association with this civilizing aspect are the Aphrodite influence through beauty of dress, and the beauty of the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Aphrodite, the Foam-born. It is said that when she emerged from the sea that gave her life, the earth burst into flower wherever she stepped. Laughter and beauty, love and desire, fertility and abundance, are her gifts to us.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is no wonder that those objects and substances believed to enhance the desire for union between woman and man, and the vigor to consummate it, to strengthen our ability to bear children, grow crops, and otherwise create our world, are called aphrodisiacs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The dark side of Aphrodite is her aspect as the obsessive, possessive lover. This is reflected in some of the philtres and potions that were intended to subjugate "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("or enthrall the object of love whether they wished it or not.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The higher aspects of physical union are expressed in the erotic literature and practices of many cultures from antiquity to the present. Hindu, Arab, and Chinese love manuals all express respect and even reverence for the physical union of male and female which is seen as a reflection of higher, divine union. This stress on the importance of a properly balanced exchange of sexual energies goes back to our earliest beginnings and can be read in the rites accompanying the ancient rituals of the Fertile Crescent civilizations and those of proto-historical India.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APHRODITE KALLIPYGOS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Aphrodite, the Greek goddess of love, was represented, in poetry and sculpture, as endowed with such alluring charms, such sexual enticements, as to infatuate even the wise man, as Homer adds. Throughout Greece, in temples dedicated to the goddess, her kallipygian beauty was stressed as a factor in her worship. (see KALLIPYGIAN COQUETRY)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APOTHECARY BURTON")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In the seventeenth century an English apothecary named Robert Burton opened a factory in the town of Colchester where he produced aphrodisiac confections derived from sea holly roots. Sea holly (or eryngo) which grows wild along the English coast is mentioned by a number of Elizabethan writers, including Dryden and Shakespeare, in connection with aphrodisiacs. "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("Burton’s candies were called “kissing comfits.” (see ERYNGO)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APPLE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In ancient Greece and in Rome the apple had a symbolic erotic connotation. Lovers or would-be lovers exchanged apples as presents, or threw them to each other.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mythologically, a certain Acontius was in love with Cydippe. As the love was reciprocated, he wrote ‘I swear by Artemis that I will wed Acontius on an apple. Cydippe read the words aloud, and although she threw the apple away, she finally accepted Acontius.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Powdered white thorn-apples, black pepper, honey, long pepper, compounded into an ointment, is recommended, in Hindu sexology, as an irresistable means of achieving sexual mastery. (see APHRODISIAC OINTMENT)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In medieval Germany it was a popular belief that an apple steeped in the perspiration of the loved woman would excite amorous advances.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ancient Scandinavian legends describe apples as food of the gods. The belief was that the gods, grown old and decrepit, were rejuvenated by feasting on apples.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APRICOT BRANDY")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Considered an aphrodisiac liqueur. The probable reason is that it is pleasant in itself and is conducive to a "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("relaxed condition of well-being.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("APULEIUS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A Roman orator and philosopher who flourished in the second century A.D. He also wrote a strange romantic novel entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Golden Ass")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metamorphoses.")]), _vm._v(" It contains exciting adventures, magic episodes, unique festivals and rites, and a great deal of matter relating to sexual activities, aphrodisiacs and erotic rituals.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The novel has the force of a verbal aphrodisiac. It belongs in the same a category as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Decameron")]), _vm._v(" and Honoré de Balzac’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Contes Drólatiques.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AQUAMARINE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("An engraved aquamarine was used among Arabs as a love charm to secure conjugal fidelity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ARABIAN NIGHTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In the story of Ala-al Din Abu-Al, a druggist prepares a love potion containing cubebs, a variety of pepper:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("After hearing Sham-al Din’s story, the druggist betook himself to a hashish seller, of whom he bought two ounces of concentrated Roumi opium and equal parts of Chinese cubebs, cinnamon, cloves, cardamom, ginger, white pepper, and mountain shiek—an aphrodisiac lizard; and pounding them all together boiled them in sweet olive oil; after which he added three ounces of male frankincense in fragments and a cupful of coriander "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("seed, and macerating the whole made it into an electuary with Roumi bee-honey. Then he put the confection in the bowl and carried it to the merchants, saying:")])]), _vm._v(" "), _c('p', {
    staticClass: "quotes"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Take of my electuary with a spoon after supping, and wash it down with a sherbet made of rose conserve; but first sup off mutton and house pigeon plentifully seasoned and hotly spiced.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ARABS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Of all peoples, the Arabs have made almost a science or erotic writing. Their literature abounds in studies and manuals that discuss the physiology of love, amorous skills, aphrodisiacs and anaphrodisiacs, in a wider sense, the entire range of sexual relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Perfumed Garden")]), _vm._v(", one of the major erotic manuals originally intended for Moslem use, is full of anecdotes illustrating some particular phase of lovemaking—pervaded, in most cases, by expressions of devoutness, sanctity, poetic imagery, and verse. Human sexuality was regarded as sacred and the stimulation of desire was considered a devout duty.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ARMAGNAC")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Henry VI of France, before confronting his numerous mistresses, regularly fortified himself with a tiny glass of this dry brandy named for the Armangnac region of southwest France.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AROMATIC BATHS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Among the Romans, especially in the luxurious Imperial "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("Age, aromatic baths constituted a regular prelude and instigation for erotic practice. Similarly, perfumed unguents were used by attendants who massaged the bodies of the bathers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The impact of perfume on sexual response has long been known to Oriental sexologists: Arabic manuals are packed with hints and advice on the use of such aids. Contemporary scientists are discovering that the Arabs were right. (see PERFUME and PHERAMONES)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ARTEMISIA")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("This genus of aromatic plants includes wormwood and mugwort. Used as a condiment in erotic cookery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ARTICHOKE")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A bristly plant whose edible parts are the fleshy bases of the leaves. Considered a powerful aphrodisiac, especially in France. Street vendors in Paris had a special cry:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quotes"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Artichokes! Artichokes!")])]), _vm._v(" "), _c('p', {
    staticClass: "quotes"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heats the body and the spirit.")])]), _vm._v(" "), _c('p', {
    staticClass: "quotes"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Heats the genitals.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Artichokes were popular as an aphrodisiac since they supposedly have the power to prevent premature ejaculation. (This is not proven.) However, eating artichokes may directly produce euphoria which, in an indirect fashion, is accompanied by the pleasant kind of relaxation conducive to lovemaking.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("INTIMATE ARTICHOKES WITH PASSION PILAF")])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("2 small to medium globe artichokes")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("1 Tbsp. olive oil")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("1 1/4 cups cooked brown rice")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("1/2 cup diced onion")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("1 tsp. dried mint")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("1 garlic clove crushed")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("juice of 1/2 lemon")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("1/2 cup diced celery")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("2 Tbsp. parsley")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("2 Tbsp. sunflower seeds")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("1/2 cup crummbled feta cheese")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentz"
  }, [_vm._v("Remove the stems of the artichokes as well as the discolored, tough bottom row of leaves. Bring two inches of water to a boil. Place artichokes in a steamer and cover. Steam for about 35 minutes. They should be tender enough to pull the leaves out easily. Let cool at room temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stuffing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentz"
  }, [_vm._v("Sauté the sunflower seeds, celery, onion, garlic in the oil until the onions are clear. Then mix with rice, mint, lemon and parsley. Remove the top leaf cluster from the artichokes and scoop out the hairy center. Be careful not to remove the tender heart just below the hairy bit. Spread out the leaves and fill with the Passion Pilaf. Cover with feta cheese and bake at 325 degrees for 25 minutes. Place on small decorative plates and eat by candlelight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ASOKA")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In Hindu sexology the asoka plant, the lotus, and the jasmine stimulate desire. The lotus itself is associated with the Lotus-Woman, the Hindu feminine ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ASPARAGUS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("A daily dish of asparagus, first boiled then fried in fat, with egg yolks and a sprinkling of condiments, will, "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("according to an Arab manual, produce considerable erotic effect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("ASS")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In Greek mythology, the ass was the symbol of sexual potency. This animal was associated with satyrs and sileni, creatures who in their characteristics resembled satyrs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("On one occasion, at a Dionysiac festival, Priapus, personification of the sexual impulse, was about to consummate his sexual desire for the nymph Lotis. The braying of an ass, however, interrupted the performance. Since then, the ass became a sacrificial victim of Priapus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("AUDILE APHRODISIAC")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("The voice, in inflection or tone or volume or by some other peculiarity of the individual, can be a deeply stirring incitement. Thus it is possible to fall in love with a voice, both fictionally and in reality.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99293496","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chapter01.vue
// module id = 69
// module chunks = 0